// 1977 Topps Star Wars Series 3 — GENERATED by pipeline-publish (2026-05-30)
// =============================================================================
// Auto-generated from the set draft. Colors, sub-set types, ordering, and the
// SET_REGISTRY entry below are filled in. REVIEW before committing:
//   - Any placeholder color marker (a parallel name not in the standard color
//     map; the commit guard blocks until every one is resolved).
//   - Rule-7 base serial slots on numbered auto/sketch sub-sets (see in-array
//     notes; the warnings list above flags only sub-sets actually missing one).
//   - Sanity-check the auto-classified sub-set `type` and ordering.
//   - Any placeholder in the SET_REGISTRY entry below (only present if no DB
//     sets row exists for this slug, or fields are blank).
//   - A source/specimen pass on parallel names + print runs.
//   - node --check src/sets/1977-series-3.js if committing by hand, then commit + push.
//
// SET_REGISTRY entry (paste into src/setRegistry.js):
//   {
//     id: "1977-series-3",
//     name: "1977 Topps Star Wars Series 3",
//     shortName: "Series 3 1977",
//     year: 1977,
//     brand: "Topps",
//     category: 'Star Wars',
//     releaseDate: "1977",
//     totalCards: 77,
//     description: "Topps 1977 Topps Star Wars Series 3 trading card set.",
//     color: "#888aa0",
//     accentColor: "#f0c040",
//     dataFile: "1977-series-3",
//   },
// =============================================================================

export const SETS = [
  {
    id: "base",
    type: "base",
    title: "BASE",
    parallels: [],
    cards: [
        { n: "133", name: "Ben and Luke Help C-3P0 to His Feet" },
        { n: "134", name: "Luke Dreams of Being a Star Pilot" },
        { n: "135", name: "Cantina Troubles!" },
        { n: "136", name: "Danger From All Sides!" },
        { n: "137", name: "Luke Attacked by a Strange Creature!" },
        { n: "138", name: "On the Tracks of the Droids" },
        { n: "139", name: "Han Solo . . . Hero or Mercenary?" },
        { n: "140", name: "R2-D2, Where Are You?" },
        { n: "141", name: "Some Quick Thinking by Luke!" },
        { n: "142", name: "Darth Vader Inspects the Captured Ship" },
        { n: "143", name: "Droids on the Sand Planet" },
        { n: "144", name: "Harrison Ford as Han Solo" },
        { n: "145", name: "Escape From the Death Star!" },
        { n: "146", name: "Luke Skywalker's Aunt Preparing Dinner" },
        { n: "147", name: "Bargaining With the Jawas!" },
        { n: "148", name: "The Fearsome Stormtroopers!" },
        { n: "149", name: "The Evil Grand Moff Tarkin" },
        { n: "150", name: "Shoot-Out at the Chasm!" },
        { n: "151", name: "Planning an Escape!" },
        { n: "152", name: "Spirited Princess Leia!" },
        { n: "153", name: "The Fantastic Droid Threepio!" },
        { n: "154", name: "Princess Leia comforts Luke!" },
        { n: "155", name: "The Escape Pod is jettisoned!" },
        { n: "156", name: "R2-D2 is lifted aboard!" },
        { n: "157", name: "\"Learn about the Force, Luke!\"" },
        { n: "158", name: "Rebel victory" },
        { n: "159", name: "Luke Skywalker's home" },
        { n: "160", name: "Destroying a world!" },
        { n: "161", name: "Preparing for the raid!" },
        { n: "162", name: "Han Solo cornered by Greedo!" },
        { n: "163", name: "Caught in the tractor beam!" },
        { n: "164", name: "Tusken Raiders capture Luke!" },
        { n: "165", name: "escaping from stormtroopers!" },
        { n: "166", name: "A close call for Luke and Princess Leia!" },
        { n: "167", name: "Surrounded by Lord Vader's soldiers!" },
        { n: "168", name: "Hunting the fugitives" },
        { n: "169", name: "Meeting at the Death Star!" },
        { n: "170", name: "Luke and the princess . . trapped!" },
        { n: "171", name: "\"The walls are moving!\"" },
        { n: "172", name: "Droids in the Escape Pod" },
        { n: "173", name: "The stormtroopers" },
        { n: "174", name: "Solo aims for trouble!" },
        { n: "175", name: "A closer look at a \"Jawa\"" },
        { n: "176", name: "Luke Skywalker's dream" },
        { n: "177", name: "Solo swings into action!" },
        { n: "178", name: "The Star Warriors!" },
        { n: "179", name: "Stormtroopers search the spaceport!" },
        { n: "180", name: "Princess Leia honors the victors" },
        { n: "181", name: "Peter Cushing as Grand Moff Tarkin" },
        { n: "182", name: "Deadly blasters!" },
        { n: "183", name: "Dave Prowse as Darth Vader" },
        { n: "184", name: "Luke and his uncle" },
        { n: "185", name: "Luke on Tatooine" },
        { n: "186", name: "The Jawas" },
        { n: "187", name: "Threepio and friend" },
        { n: "188", name: "Starship under fire!" },
        { n: "189", name: "Mark Hamill as Luke" },
        { n: "190", name: "Carrie Fisher as Princess Leia" },
        { n: "191", name: "Life on the desert world" },
        { n: "192", name: "Liberated Princess!" },
        { n: "193", name: "Luke's uncle buys Threepio!" },
        { n: "194", name: "Stormtroopers attack!" },
        { n: "195", name: "Alec Guinness as Ben Kenobi" },
        { n: "196", name: "Lord Darth Vader" },
        { n: "197", name: "Leia blasts a Stormtrooper!" },
        { n: "198", name: "Luke decides to leave Tatooine!" },
    ],
  },
  {
    id: "sticker",
    type: "insert",
    title: "STICKER",
    parallels: [],
    cards: [
        { n: "23", name: "Dave Prowse as Darth Vader" },
        { n: "24", name: "Droids on the Sand Planet" },
        { n: "25", name: "The Escape Pod is Jettisoned" },
        { n: "26", name: "The Fantastic Droid Threepio" },
        { n: "27", name: "A Closer Look at a \"Jawa\"" },
        { n: "28", name: "Peter Cushing as Grand Moff Tarkin" },
        { n: "29", name: "Han Solo Hero or Mercenary?" },
        { n: "30", name: "The Fearsome Stormtroopers" },
        { n: "31", name: "Princess Leia Comforts Luke" },
        { n: "32", name: "Preparing for the Raid!" },
        { n: "33", name: "Solo Aims for Trouble!" },
    ],
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

// Fallback exports used by Checklist.js for any sub-set with no inline `parallels`.
// Every sub-set above has its own inline array, so these stay empty.
export const PARALLELS = [];
export const AUTO_PARALLELS = [];
export const INSERT_PARALLELS = [];
